import mainEmptyContent from "../../assets/mainEmptyContent.png";
import EmptyContentList from "./components/EmptyContentList";

const EmptyContent = () => {
  return (
    <div>
      <div>
        <img src={mainEmptyContent} alt="Empty content" />
        <EmptyContentList />
      </div>
    </div>
  );
};

export default EmptyContent;
